























































import Vue, { PropOptions } from 'vue'
import Button from '@/components/Button.vue'
import Loader from '@/components/Loader.vue'
import { Modal as ModalProps } from '@/interfaces/Modal'
import { KEY_TAB, KEY_ESC, TABBABLE_ELEMENTS } from '@/constants'

export default Vue.extend({
  name: 'modal',
  components: { Button, Loader },
  data() {
    return {
      dialogEl: null as any,
      modalEl: null as any,
      focusableEls: null as any,
      focusedElBeforeOpen: null as any,
    }
  },
  props: {
    modal: {
      type: Object,
      default: () => [],
    } as PropOptions<ModalProps[]>,
  },
  computed: {
    hasBodySlot(): boolean {
      return !!this.$slots.body
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit')
    },
    handleKeydown(e: KeyboardEvent) {
      // while open, prevent tabbing outside the dialog
      // allow the ESC key to close the dialog

      const handleBackwardTab = () => {
        if (document.activeElement === this.focusableEls[0]) {
          e.preventDefault()
          this.focusableEls[this.focusableEls.length - 1].focus()
        }
      }
      const handleForwardTab = () => {
        if (document.activeElement === this.focusableEls[this.focusableEls.length - 1]) {
          e.preventDefault()
          this.focusableEls[0].focus()
        }
      }

      switch (e.keyCode) {
        case KEY_TAB:
          if (this.focusableEls.length === 1) {
            e.preventDefault()
            break
          }
          if (e.shiftKey) {
            handleBackwardTab()
          } else {
            handleForwardTab()
          }
          break
        case KEY_ESC:
          this.close()
          break
        default:
          break
      }
    },
    attachListener(element: any, event: string, handler: any) {
      if (element && event && handler) {
        document.addEventListener
          ? element.addEventListener(event, handler, false)
          : element.attachEvent('on' + event, handler)
      }
    },
    removeListener(element: any, event: string, handler: any) {
      if (element && event) {
        document.removeEventListener
          ? element.removeEventListener(event, handler, false)
          : element.detachEvent('on' + event, handler)
      }
    },
    refreshFocusableEls() {
      const focusableEls = this.dialogEl.querySelectorAll(TABBABLE_ELEMENTS)
      this.focusableEls = Array.prototype.slice.call(focusableEls)
    },
  },
  mounted() {
    this.dialogEl = this.$refs.dialog
    this.modalEl = this.$refs.modal
    this.focusedElBeforeOpen = document.activeElement
    this.refreshFocusableEls()
    this.modalEl.setAttribute('aria-hidden', false)
    this.focusableEls[0].focus()
    this.attachListener(document, 'keydown', this.handleKeydown)
  },
  updated() {
    this.refreshFocusableEls()
  },
  beforeDestroy() {
    this.modalEl.setAttribute('aria-hidden', true)
    this.removeListener(document, 'keydown', this.handleKeydown)
    this.focusedElBeforeOpen.focus()
  },
})
